import {
  VALIDATE_SHOPIFY_URL_SUCCESS,
  VALIDATE_SHOPIFY_URL_ERROR,
  CLEAR_VALIDATE_SHOPIFY_URL,
  CONNECT_SHOPIFY_STORE_SUCCESS,
  CONNECT_SHOPIFY_STORE_ERROR,
  CLEAR_CONNECT_SHOPIFY_STORE,
  SHOPIFY_STORE_INFO_SUCCESS,
  SHOPIFY_STORE_INFO_ERROR,
  CLEAR_SHOPIFY_STORE_INFO,
  DISCONNECT_SHOPIFY_STORE_SUCCESS,
  DISCONNECT_SHOPIFY_STORE_ERROR,
  CLEAR_DISCONNECT_SHOPIFY_STORE,
  RESYNC_SHOPIFY_STORE_SUCCESS,
  RESYNC_SHOPIFY_STORE_ERROR,
  CLEAR_RESYNC_SHOPIFY_STORE,
  SYNCHRONIZE_SHOPIFY_PRODUCTS_SUCCESS,
  SYNCHRONIZE_SHOPIFY_PRODUCTS_ERROR,
  CLEAR_SYNCHRONIZE_SHOPIFY_PRODUCTS,
} from 'redux/integrations/types';

const initialState = {
  validateShopifyUrlSuccess: null,
  validateShopifyUrlError: null,
  connectShopifyStoreSuccess: null,
  connectShopifyStoreError: null,
  shopifyStoreInfo: null,
  shopifyStoreInfoError: null,
  disconnectShopifyStoreSuccess: null,
  disconnectShopifyStoreError: null,
  resyncShopifyStoreSuccess: null,
  resyncShopifyStoreError: null,
  synchronizeShopifyProductsSuccess: null,
  synchronizeShopifyProductsError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_SHOPIFY_URL_SUCCESS:
      return {
        ...state,
        validateShopifyUrlSuccess: action.payload.data,
        validateShopifyUrlError: null,
      };
    case VALIDATE_SHOPIFY_URL_ERROR:
      return {
        ...state,
        validateShopifyUrlSuccess: null,
        validateShopifyUrlError: action.payload.data,
      };
    case CLEAR_VALIDATE_SHOPIFY_URL:
      return {
        ...state,
        validateShopifyUrlSuccess: null,
        validateShopifyUrlError: null,
      };
    case CONNECT_SHOPIFY_STORE_SUCCESS:
      return {
        ...state,
        connectShopifyStoreSuccess: action.payload.data,
        connectShopifyStoreError: null,
      };
    case CONNECT_SHOPIFY_STORE_ERROR:
      return {
        ...state,
        connectShopifyStoreSuccess: null,
        connectShopifyStoreError: action.payload.data,
      };
    case CLEAR_CONNECT_SHOPIFY_STORE:
      return {
        ...state,
        connectShopifyStoreSuccess: null,
        connectShopifyStoreError: null,
      };
    case SHOPIFY_STORE_INFO_SUCCESS:
      return {
        ...state,
        shopifyStoreInfo: action.payload.data,
        shopifyStoreInfoError: null,
      };
    case SHOPIFY_STORE_INFO_ERROR:
      return {
        ...state,
        shopifyStoreInfo: null,
        shopifyStoreInfoError: action.payload.data,
      };
    case CLEAR_SHOPIFY_STORE_INFO:
      return {
        ...state,
        shopifyStoreInfo: null,
        shopifyStoreInfoError: null,
      };
    case DISCONNECT_SHOPIFY_STORE_SUCCESS:
      return {
        ...state,
        disconnectShopifyStoreSuccess: action.payload.data,
        disconnectShopifyStoreError: null,
      };
    case DISCONNECT_SHOPIFY_STORE_ERROR:
      return {
        ...state,
        disconnectShopifyStoreSuccess: null,
        disconnectShopifyStoreError: action.payload.data,
      };
    case CLEAR_DISCONNECT_SHOPIFY_STORE:
      return {
        ...state,
        disconnectShopifyStoreSuccess: null,
        disconnectShopifyStoreError: null,
      };
    case RESYNC_SHOPIFY_STORE_SUCCESS:
      return {
        ...state,
        resyncShopifyStoreSuccess: action.payload.data,
        resyncShopifyStoreError: null,
      };
    case RESYNC_SHOPIFY_STORE_ERROR:
      return {
        ...state,
        resyncShopifyStoreSuccess: null,
        resyncShopifyStoreError: action.payload.data,
      };
    case CLEAR_RESYNC_SHOPIFY_STORE:
      return {
        ...state,
        resyncShopifyStoreSuccess: null,
        resyncShopifyStoreError: null,
      };
    case SYNCHRONIZE_SHOPIFY_PRODUCTS_SUCCESS:
      return {
        ...state,
        synchronizeShopifyProductsSuccess: action.payload.data,
        synchronizeShopifyProductsError: null,
      };
    case SYNCHRONIZE_SHOPIFY_PRODUCTS_ERROR:
      return {
        ...state,
        synchronizeShopifyProductsSuccess: null,
        synchronizeShopifyProductsError: action.payload.data,
      };
    case CLEAR_SYNCHRONIZE_SHOPIFY_PRODUCTS:
      return {
        ...state,
        synchronizeShopifyProductsSuccess: null,
        synchronizeShopifyProductsError: null,
      };
    default:
      return state;
  }
};
